import textMap from "./textMap";

const TranslatedText = ({ id }) => {
  return textMap[id];
};

export default TranslatedText;
